"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = require("lodash");
function objectToMap(obj) {
    const map = new Map();
    lodash_1.keys(obj).forEach(key => {
        map.set(key, obj[key]);
    });
    return map;
}
exports.default = objectToMap;
